import { useState } from "react";
import { useLatest } from "../../../hooks";
import { fetchProductOptions } from "../utils";

export function useProductOptions(filter) {
  const [options, setOptions] = useState();
  useLatest(
    async (signal) => {
      if (filter == null) {
        setOptions([]);
        return;
      }

      setOptions(null);
      setOptions(await fetchProductOptions(signal, filter));
    },
    [filter],
  );

  return { options: options ?? [], loading: options == null };
}
